<template>
    <ActionModal
        v-model="isOpen"
        :title="title"
        :description="description"
        :error="errorMessage"
        :is-loading="isDeleting"
        @cancel="cancelDeletion"
    >
        <template #actions>
            <SrButton type="delete" :loading="isDeleting" :disabled="isDeleting" @click="deleteItem"> Delete </SrButton>
        </template>
    </ActionModal>
</template>

<script>
import { SrButton } from '@ads/design-system';
import ActionModal from '@/views/ActionModal';

export default {
    name: 'SingleDeleteModal',
    components: {
        SrButton,
        ActionModal,
    },
    props: {
        /**
         * @model is modal open
         */
        value: {
            type: Boolean,
            default: false,
        },
        itemDescription: {
            type: String,
            required: true,
        },
        id: {
            type: [String, Number],
            required: true,
        },
        callback: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            isOpen: this.value,
            isDeleting: false,
            errorMessage: null,
        };
    },
    computed: {
        title() {
            return 'Delete Action';
        },
        description() {
            return `Are you sure you want to delete ${this.itemDescription}?`;
        },
    },
    watch: {
        value(newValue) {
            this.isOpen = newValue;
        },
        isOpen() {
            this.emitIsOpenChange();
        },
    },
    methods: {
        emitIsOpenChange() {
            this.$emit('input', this.isOpen);
        },
        cancelDeletion() {
            this.clear();
            this.$emit('cancel');
        },
        handleDeletionSuccess() {
            this.clear();
            this.$emit('completed');
        },
        handleDeletionError(error) {
            if (error?.response?.message) {
                this.errorMessage = error.response.message;
                return;
            }
            this.errorMessage = `Could not delete ${this.itemDescription}.`;
        },
        async deleteItem() {
            this.isDeleting = true;
            this.errorMessage = null;
            try {
                await this.callback(this.id);
                this.handleDeletionSuccess();
            } catch (error) {
                this.handleDeletionError(error);
            } finally {
                this.isDeleting = false;
            }
        },
        clear() {
            this.isDeleting = false;
            this.errorMessage = null;
        },
    },
};
</script>
